module.exports = __webpack_public_path__ + "images/b341f22d6f4f7cf0800990d2d27a8bb9.jpg";